// import { upperFirst, words } from "lodash-es";
import constants from "@/utils/constants";
import routes from "@/router/routes";
import store from "@/store";
import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

// const docTitle = (toRoute) => {
//   if (toRoute?.meta?.title) {
//     return toRoute.meta.title;
//   }

//   const nameWords = words(toRoute.name);

//   return nameWords.map((word) => upperFirst(word)).join(" ");
// };

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  // removing because causing issues
  // if (to.name === from.name) {
  // return;
  // }

  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (!store.getters["auth/isLoggedIn"]) {
      // if already on login, routing to login can fail
      // handle that case by doing nothing
      if (from.name === "login") {
        return;
      }

      next({
        name: "login",
        query: { redirect: to.path },
      });
    }

    next();
  } else if (to.matched.some((record) => record.meta.authGuard)) {
    if (store.getters["auth/isLoggedIn"]) {
      next({
        name: constants.HOME_ROUTE,
      });
    }

    next();
  }

  next();
});

router.afterEach((to, from) => {
  store.dispatch("nav/setCurrentRoute", to);
  if (to.name === from.name) {
    return;
  }

  // document.title = docTitle(to);

  store.dispatch("analytics/send", { name: "navigation", data: to });
});

export default router;
